var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgYachtWidth = function SvgYachtWidth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.333h-7c-5.833 0-8.167 3.334-8.167 11.667v10c0 8.333 2.334 11.667 8.167 11.667h7c5.833 0 8.167-3.334 8.167-11.667V15c0-8.333-2.334-11.667-8.167-11.667Z",
    stroke: "#B0E9E9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21h-1.45l-1.8-6.74h1.33l.63 2.49a107.174 107.174 0 0 1 .56 2.49l.08.39c.213-.84.473-1.8.78-2.88l.68-2.39h1.02l.69 2.39.8 2.9c.167-.927.373-1.897.62-2.91l.61-2.48h1.28L22.61 21h-1.46l-.61-2.13a99.36 99.36 0 0 1-.43-1.5c-.113-.433-.19-.723-.23-.87l-.05-.23c-.093.467-.327 1.333-.7 2.6L18.5 21Z",
    fill: "#B0E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 28.333h16.666m-16.666 0L13.519 25m-1.852 3.333 1.852 3.334m14.814-3.334L26.482 25m1.851 3.333-1.851 3.334",
    stroke: "#B0E9E9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgYachtWidth as ReactComponent };
export default __webpack_public_path__ + "static/media/yacht-width.e18cee80.svg";